// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sodI","colMin":"styles_colMin__2NOds"};